function BtnClose (props) {
    return (
        <button className='m-1 btn btn-sm btn-light' onClick={props.action}><i className='text-black fas fa-times' /></button>
    );
}

export default BtnClose;